/*
 * Copyright (c) 2022-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Directive, OnInit} from '@angular/core';
import {User} from '../shared/model/user';
import {UserService} from '../shared/user.service';


@Directive()
export abstract class BaseComponentDirective implements OnInit {

    private user: User;
    protected constructor(protected userService: UserService) {
        this.user = this.userService.user;
    }


    ngOnInit() {
    }

    public getUserDetailsObject() {
        return this.user;
    }

}
